import React from 'react'

function StaticSKS() {
  return (
    <embed src="\pdfs\E2.1.1.2_SKS4-3-duo_Static_cooling_ceiling_system_03.2008-1-Web_kr.pdf" width="100%" height="2100px" />
  )
}

export default StaticSKS